<template>
  <div class="storeApply">
    <!-- 基本信息 -->
    <div class="list">
      <!-- <div class="item flex ali_center" @click="show_add4 = true">
        <div class="left">商户类型</div>
        <input
          type="text"
          disabled
          v-model="choose_name3"
          placeholder="请选择商户类型"
          placeholder-style="color: #333;font-size:0.30rem"
        />
      </div> -->
      <div class="item flex ali_center">
        <div class="left">门店名称</div>
        <input
          type="text"
          v-model="shopname"
          placeholder="请填写门店名称"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">门店简介</div>
        <input
          type="text"
          v-model="mercName"
          placeholder="请填写门店简介"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>

      <div class="item flex ali_center">
        <div class="left">手机号</div>
        <input
          type="number"
          v-model="phone"
          placeholder="请填写手机号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item2 flex ali_center" @click="showAddress = true">
        <div class="left">门店地址</div>
        <div class="right flex ali_center flex_between">
          <spen class="a">{{ addressText }}</spen>
          <spen class="iconfont icon-dizhi"></spen>
        </div>
      </div>
      <div class="item flex ali_center">
        <div class="left">详细地址</div>
        <input
          type="text"
          v-model="detail"
          placeholder="请填写门店详细地址"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item2 flex ali_center">
        <div class="left">门店经纬度</div>
        <div
          class="right flex ali_center flex_between"
          v-if="!mapShow && !latitude2"
          @click="getMarkers"
        >
          <spen class="a" style="color: #999;">请选择门店经纬度</spen>
          <spen class="iconfont icon-dizhi"></spen>
        </div>
        <div
          class="right flex ali_center flex_between"
          @click="getMarkers"
          v-else
        >
          <spen class="a">{{ latitude2 }} , {{ longitude2 }}</spen>
          <spen class="iconfont icon-dizhi"></spen>
        </div>
      </div>
      <div class="item flex ali_center" @click="date_show1 = true">
        <div class="left">营业开始时间</div>
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ certStartTime || "请选择营业开始时间" }}
        </div>
      </div>
      <div class="item flex ali_center" @click="date_show2 = true">
        <div class="left">营业结束时间</div>
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ bussAuthEndTime || "请选择营业结束时间" }}
        </div>
      </div>
      <div class="logo">
        <div class="left on">上传门店logo</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="logo" v-if="logo" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
    </div>
    <!-- <div class="submit" @click="submit(0)">保存当前信息</div> -->
    <div class="submit" @click="submit(1)">保存</div>
    <!-- <div class="examine" @click="$goNext('/pages/store/record')">
      查看审核记录
    </div> -->

    <div v-if="showAddress">
      <CitySelect
        ref="cityselect"
        v-model="showAddress"
        :callback="result"
        :items="addressList"
        :ready="ready"
        provance=""
        city=""
        area=""
      ></CitySelect>
    </div>
    <div v-if="showAddress2">
      <CitySelect
        ref="cityselect"
        v-model="showAddress2"
        :callback="result2"
        :items="addressList2"
        :ready="ready"
        provance=""
        city="false"
        area="false"
      ></CitySelect>
    </div>
    <div v-if="showAddress3">
      <CitySelect
        ref="cityselect"
        v-model="showAddress3"
        :callback="result3"
        :items="addressList3"
        :ready="ready"
        provance=""
        city=""
        area="false"
      ></CitySelect>
    </div>

    <div class="mask" v-if="date_show1" @click="date_show1 = false"></div>
    <div v-if="date_show1" class="DatetimePicker">
      <DatetimePicker
        type="time"
        v-model="DatecertStartTime3"
        :min-hour="'00'"
        :max-hour="'24'"
        title="请选择时间"
        @confirm="bindDateChange1"
        @cancel="date_show1 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show2" @click="date_show2 = false"></div>
    <div v-if="date_show2" class="DatetimePicker">
      <DatetimePicker
        type="time"
        v-model="DatecertStartTime3"
        :min-hour="'00'"
        :max-hour="'24'"
        title="请选择时间"
        @confirm="bindDateChange2"
        @cancel="date_show2 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show3" @click="date_show3 = false"></div>
    <div v-if="date_show3" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange3"
        @cancel="date_show3 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show4" @click="date_show4 = false"></div>
    <div v-if="date_show4" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange4"
        @cancel="date_show4 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show5" @click="date_show5 = false"></div>
    <div v-if="date_show5" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange5"
        @cancel="date_show5 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show6" @click="date_show6 = false"></div>
    <div v-if="date_show6" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange6"
        @cancel="date_show6 = false"
      >
      </DatetimePicker>
    </div>
    <!-- <div>
      <iframe
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        scrolling="no"
        id="map"
        :src="
          'https://apis.map.qq.com/ws/place/v1/search?boundary=nearby(' +
            latitude +
            ',' +
            longitude +
            ',' +
            1000 +
            ',' +
            1 +
            ')&keyword=' +
            addressText +
            detail +
            '&get_subpois=0&key=6JZBZ-L5YH3-7IW3C-YH4WW-UP6RT-65FHK' +
            'output=JSONP&callback=onCallback'
        "
      >
      </iframe>
    </div> -->
    <div class="geoPage" v-if="mapShow">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        :src="
          'https://3gimg.qq.com/lightmap/components/locationPicker2/index.html?coord=' +
            latitude +
            ',' +
            longitude +
            '&referer=myapp&type=1&&key=6JZBZ-L5YH3-7IW3C-YH4WW-UP6RT-65FHK'
        "
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { storeInfo, storeUpdate } from "../../api/user";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getCity_new, gettreea } from "@api/public";
// import setMeal from "@components/public/setMeal.vue";
import VueCoreImageUpload from "vue-core-image-upload";
import { VUE_APP_API_URL } from "@utils";
import { DatetimePicker } from "vant";
import cookie from "@utils/store/localStorage";
// import $ from "jquery";
export default {
  name: "storeApply4",
  components: {
    CitySelect,
    DatetimePicker,
    VueCoreImageUpload
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      baseline: false,
      choose_name: "",
      choose_name2: "",
      choose_name5: "",
      choose_name6: "",
      choose_name3: "请选择商户类型",
      type: 0,
      type2: 1,
      status: -1,
      statusmsg: "",
      signUrl: "",
      checked: false,
      showAddress: false,
      showAddress3: false,
      valueArr: [0, 0, 0],
      valueArr3: [0, 0],
      id: 0,
      uid: "",
      mapShow: false,
      ready: false,
      addressText: "广东省 广州市 天河区",
      addressText8: "请选择门店经纬度",
      showAddress8: false,
      addressText3: "请选择支行地址",
      area: "请选择门店所在街道",
      addressList: [],
      shopname: "",
      contactName: "",
      mercName: "",
      map: null,
      realname: "",
      phone: "",
      address: "",
      detail: "吉山上街23巷3号",
      desc: "",
      logo: "",
      logo_img: "",
      imgUrl: "",
      imgUrl2: "",
      imgNegative: "",
      imgNegative2: "",
      imgPositive: "",
      imgPositive2: "",
      imgUrl_img: "",
      imgUrl2_img: "",
      imgNegative_img: "",
      imgNegative2_img: "",
      imgPositive_img: "",
      imgPositive2_img: "",
      shop_bg: "",
      license: "",
      shop_bg_img: "",
      license_img: "",
      grantAuthUrl: "",
      licenseUrl: "",
      grantAuthUrl_img: "",
      licenseUrl_img: "",
      card_from: "",
      card_back: "",
      latitude2: "",
      longitude2: "",
      contactLine: "",
      province: "",
      city: "",
      province3: "",
      city3: "",
      district: "",
      province_code: "",
      city_code: "",
      district_code: "",
      province2: "",
      city2: "",
      district2: "",
      contact_line: [],
      show_add3: false,
      combo: 0,
      branch: "",
      stick: "请选择让利比例",
      address_jw: "",
      showAddress2: false,
      addressList2: [],
      addressList3: [],
      valueArr2: [0],
      showStreet: false,
      show_add: false,
      show_add2: false,
      // show_add3: false,
      show_add5: false,
      show_add6: false,
      show_add4: false,
      bussAuthEndTime: "",
      certStartTime: "",
      bussAuthEndTime2: "",
      certStartTime2: "",
      bussAuthEndTime3: "",
      date_show3: false,
      date_show1: false,
      date_show2: false,
      date_show5: false,
      date_show4: false,
      date_show6: false,
      certStartTime3: "",
      DatecertStartTime3: "00:00",
      startDate: new Date(1900, 1, 1),
      endDate: new Date(2100, 1, 1),
      start: false,
      open: false,
      subMercList: [],
      latitude: cookie.get("user_latitude"),
      longitude: cookie.get("user_longitude"),
      tMap: null, // 腾讯地图实例
      TXMap: null, // 腾讯地图原型
      markersData: [], // 标记数据
      infoWin: null, // 信息窗口实例
      typeOptions: []
    };
  },

  mounted() {
    this.getinitialMercInfo2();
    this.getCity();
    this.getCity2();
  },
  methods: {
    getMarkers() {
      let that = this;
      this.mapShow = true;
      window.addEventListener("message", function(evevt) {
        if (evevt.data) {
          if (evevt.data.latlng) {
            that.latitude2 = evevt.data.latlng.lat;
            that.longitude2 = evevt.data.latlng.lng;
            that.mapShow = false;
          } else {
            if (that.$route.fullPath == "/user/apply3") {
              return that.$dialog.error("请选择地图");
            }
          }
        }
      });
    },
    // 获取标记数据集合 根据项目自行实现。
    // getMarkersData() {
    //   let that = this;
    //   var data = {
    //     key: "6JZBZ-L5YH3-7IW3C-YH4WW-UP6RT-65FHK",
    //     get_poi: 0,
    //     get_subpois: 0,
    //     keyword: this.addressText + this.detail
    //   };
    //   var url =
    //     "https://apis.map.qq.com/ws/place/v1/search?boundary=nearby(" +
    //     this.latitude +
    //     "," +
    //     this.longitude +
    //     "," +
    //     1000 +
    //     "," +
    //     1 +
    //     ")";
    //   data.output = "jsonp";
    //   $.ajax({
    //     type: "get",
    //     dataType: "jsonp",
    //     data: data,
    //     jsonp: "callback",
    //     jsonpCallback: "QQmap",
    //     url: url,
    //     success: function(json) {
    //       if (json.data[0] && json.data[0].location) {
    //         that.latitude2 = json.data[0].location.lat;
    //         that.longitude2 = json.data[0].location.lng;
    //       } else {
    //         that.$dialog.error("详细地址请精确到门店或附近标志性建筑");
    //       }

    //       console.log(that.latitude2, that.longitude2);
    //     },
    //     error: function() {}
    //   });
    // },
    goSignUrl() {
      window.location.href = this.signUrl;
    },
    add_list() {
      this.showAddress3 = true;
      this.contact_line = [];
    },
    subBranch(item) {
      this.branch = item.branch_name;
      this.bankCard.contactLine = item.branch_no;
      this.start = true;
    },
    getinitialMercInfo2() {
      let that = this;
      storeInfo()
        .then(res => {
          that.shopname = res.data.name;
          that.addressText = res.data.address;
          that.certStartTime = res.data.start_time;
          that.bussAuthEndTime = res.data.end_time;
          that.phone = res.data.phone;
          that.mercName = res.data.introduction;
          that.latitude2 = res.data.latitude;
          that.longitude2 = res.data.longitude;
          if (!that.latitude2) {
            that.latitude = cookie.get("user_latitude");
          } else {
            that.latitude = that.latitude2;
          }
          if (!that.longitude2) {
            that.longitude = cookie.get("user_longitude");
          } else {
            that.longitude = that.longitude2;
          }
          that.logo = res.data.image;
          that.detail = res.data.detailed_address;
        })
        .catch(res => {
          console.log(res);
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    },
    bindDateChange1: function(e) {
      this.certStartTime = e + ":00";
      this.date_show1 = false;
    },
    bindDateChange2: function(e) {
      this.bussAuthEndTime = e + ":00";
      this.date_show2 = false;
    },
    bindDateChange3: function(e) {
      this.certStartTime2 = e + ":00";
      this.date_show3 = false;
    },
    bindDateChange4: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.bussAuthEndTime2 = year + "-" + month + "-" + date;
      this.date_show4 = false;
    },
    bindDateChange5: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.certStartTime3 = year + "-" + month + "-" + date;
      this.date_show5 = false;
    },
    bindDateChange6: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.bussAuthEndTime3 = year + "-" + month + "-" + date;
      this.date_show6 = false;
    },
    onclick4() {
      this.show_add6 = true;
    },
    onclick3() {
      this.show_add5 = true;
    },
    onclick2() {
      this.show_add2 = true;
    },

    onclick() {
      this.show_add = true;
    },
    checkeds() {
      this.checked = !this.checked;
    },
    Combo(type) {
      this.combo = type.num;
      this.stick = type.name;
      this.show_add3 = false;
    },
    showCombo() {
      this.show_add3 = false;
    },

    gettreea(city, area) {
      gettreea({
        city,
        area
      }).then(res => {
        this.addressList2 = res.data;
        if (res.data.length > 0) {
          this.showStreet = true;
        }
      });
    },

    result(ret) {
      console.log(ret);
      this.province2 = ret.itemName1;
      this.city2 = ret.itemName2;
      this.district2 = ret.itemName3;
      this.province_code = ret.itemValue1;
      this.city_code = ret.itemValue2;
      this.district_code = ret.itemValue3;
      this.addressText =
        ret.itemName1 + "," + ret.itemName2 + "," + ret.itemName3;
      this.cityId = ret.itemValue2;
      this.address = {
        province: this.province2,
        city: this.city2,
        district: this.district2,
        city_id: this.cityId
      };
      // this.gettreea(ret.itemName2, ret.itemName3);
    },
    result2(ret) {
      this.area = ret.itemName1;
    },
    result3(ret) {
      let province = ret.itemName1;
      let city = ret.itemName2;
      this.province3 = province;
      this.city3 = city;
      this.addressText3 = province + " " + city;
    },
    getCity() {
      getCity_new()
        .then(res => {
          // this.recity(res.data);
          this.addressList = res.data;
          this.ready = true;
        })
        .catch(res => {
          console.log(res);
        });
    },
    getCity2() {
      getCity_new()
        .then(res => {
          let addressList3 = res.data;
          for (let i = 0; i < addressList3.length; i++) {
            for (let j = 0; j < addressList3[i].c.length; j++) {
              addressList3[i].c[j].c = "";
            }
          }
          this.addressList3 = addressList3;
        })
        .catch(res => {
          console.log(res);
        });
    },
    recity(arr) {
      let province = [],
        city = [],
        area = [];
      if (arr.length) {
        let citychildren = arr[0].c || [];
        let areachildren = citychildren.length ? citychildren[0].c || [] : [];
        arr.forEach(item => {
          province.push(item);
        });
        citychildren.forEach(item => {
          city.push(item);
        });
        areachildren.forEach(item => {
          area.push(item);
        });
        this.province = province;
        this.city = city;
        this.district = area;
      }
    },
    submit() {
      let that = this;
      let data = {
        name: that.shopname,
        address: that.addressText,
        start_time: that.certStartTime,
        end_time: that.bussAuthEndTime,
        phone: that.phone,
        introduction: that.mercName,
        latitude: that.latitude2,
        longitude: that.longitude2,
        image: that.logo,
        detailed_address: that.detail
      };
      storeUpdate(data)
        .then(res => {
          that.getinitialMercInfo2();
          that.$dialog.success(res.msg);
          setTimeout(() => {
            that.$router.go(-1);
          }, 2000);
        })
        .catch(res => {
          console.log(res);
          that.$dialog.error(res.msg);
        });
    },
    errorhandle() {
      this.$dialog.error("上传图片超出10M");
    },
    imageuploaded(res) {
      if (res.status !== 200) {
        if (res.status !== 200) {
          if (res.msg == "Upload file does not exist") {
            return this.$dialog.error("上传图片超出10M");
          } else {
            return this.$dialog.error(res.msg || "上传图片失败");
          }
        }
      }

      this.logo = res.data.url;
      this.open = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.storeApply {
  padding-bottom: 0.1rem;

  .list {
    background-color: #fff;

    .item2 {
      padding: 0 0.22rem;
      height: 0.9rem;
      background-color: #fff;
      font-size: 0.28rem;
      border-bottom: 0.01rem solid #eee;

      .left {
        width: 1.95rem;
        // color: #333;
      }

      .right {
        width: 6rem;

        .iconfont {
          color: #0e98fd;
          font-size: 0.5rem;
        }

        .icon-jinru {
          color: #666;
          font-size: 0.36rem;
        }
      }
    }

    .item {
      min-height: 0.99rem;
      border-bottom: 0.01rem solid #dcdcdc;
      padding: 0 0.23rem;

      .left {
        width: 2rem;
        font-size: 0.3rem;
        line-height: 0.99rem;
      }

      input,
      picker {
        font-size: 0.3rem;
        padding: 0 0.1rem;
        height: 1rem;
        width: 100%;
      }

      textarea {
        margin-top: -0.12rem;
        width: 100%;
        height: 1.5rem;
        padding-bottom: 0.3rem;
      }

      .address {
        width: 5.46rem;

        .a {
          width: 5rem;
          font-size: 0.3rem;
        }

        .iconfont {
          font-size: 0.34rem;
        }
      }
    }

    .logo {
      padding: 0 0.28rem;

      .left {
        font-size: 0.3rem;
        line-height: 1.1rem;
        font-weight: 700;

        .a {
          font-weight: 500;
          color: #999;
        }
      }

      .pic {
        // margin-left: 0.12rem;
        width: 1.8rem;
        height: 1.8rem;
      }
    }

    .license {
      padding: 0 0.28rem;

      .left {
        font-size: 0.3rem;
        line-height: 1.1rem;
        font-weight: 700;
      }

      .pic {
        margin-left: 0.12rem;
        width: 3rem;
        height: 2.06rem;
      }

      .tips {
        width: 3rem;
        color: #999;
        font-size: 0.26rem;
        margin-top: 0.24rem;
        text-align: center;
      }
    }

    .card {
      padding: 0 0.8rem 0.6rem 0.4rem;

      .title {
        line-height: 1rem;
        font-size: 0.26rem;
      }

      .img_list {
        .item_1 {
          width: 3rem;

          .pic {
            width: 3rem;
            height: 2.06rem;
            margin-bottom: 0.24rem;
          }

          .tips {
            color: #999;
            font-size: 0.26rem;
            text-align: center;
          }
        }
      }
    }
  }

  .submit {
    width: 6.9rem;
    line-height: 0.9rem;
    text-align: center;
    background-color: #0e98fd;
    color: #fff;
    border-radius: 0.45rem;
    margin: 0.6rem 0.3rem 0.3rem;
  }
}

.addressWrapper {
  .btns {
    width: 100%;
    height: 0.86rem;
    position: fixed;
    bottom: 6rem;
    left: 0;
    z-index: 556;

    background-color: #fff;
    text-align: center;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    border-bottom: 0.01rem solid #eee;

    .cancel {
      color: #666;
    }

    .sure {
      color: #007aff;
    }
  }

  .pickerView {
    width: 100%;
    height: 6rem;
    position: fixed !important;
    bottom: 0;
    left: 0;
    z-index: 556;
    background-color: #fff;
    text-align: center;
  }
}

.detail {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
  margin-left: 0.24rem;
  color: #333;
}

.examine {
  padding: 0 0.3rem;
  text-align: right;
  color: #0e98fd;
  margin-bottom: 1rem;
}

.top {
  height: 1rem;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #ccc;

  .top_type {
    width: 20%;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
  }

  .om {
    color: #0e98fd;
    font-weight: bold;
    border-bottom: 2px solid #0e98fd;
  }
}

.shanchuB {
  background-color: #939394;
  height: 0.8rem;
  color: #fff;
  // line-height: 80rem;
  width: 5.8rem;
  padding: 0 0.3rem;
  display: flex;
  align-items: center;
  position: relative;

  .shanchuB2 {
    position: absolute;
    right: -1.5rem;
    top: 0.1rem;
    height: 0.6rem;
    width: 1.4rem;
    background-color: #0e98fd;
    border-radius: 0.3rem;
    line-height: 0.6rem;
    text-align: center;
    color: #fff;
  }
}

.jinggao {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.2rem 0.3rem;
  min-height: 0.8rem;
}

.branch_list {
  position: absolute;
  top: 1rem;
  left: 0;
  width: 7.5rem;
  max-height: 4.4rem;
  overflow-y: auto;
  background-color: #f5f5f5;
  z-index: 1000;

  .contact_li {
    height: 0.8rem;
    line-height: 0.76rem;
    text-align: center;
    font-size: 0.28rem;
    color: #333;
    border-bottom: 1px solid #ccc;
  }
}

.report {
  position: fixed;
  top: 4rem;
  left: 0.6rem;
  width: 6.3rem;
  max-height: 6rem;
  background-color: #fff;
  z-index: 1000;
  border-radius: 20rem;
  overflow-y: auto;
  padding: 0.3rem;

  .report_top {
    position: relative;
    text-align: center;
    font-size: 0.3rem;
    font-weight: bold;
    margin-bottom: 0.4rem;

    .icon-baseline-close-px {
      position: absolute;
      right: 0rem;
      top: 0rem;
      font-size: 0.4rem;
      font-weight: normal;
    }
  }

  .subMercList {
    margin-bottom: 0.3rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}

.attention {
  display: inline-block;
  height: 0.6rem;
  width: 1.2rem;
  line-height: 0.6rem;
  text-align: center;
  border-radius: 0.3rem;
  background-color: #0e98fd;
  font-size: 0.26rem;
  color: #fff;
}
.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

img {
  display: block;
  width: 100%;
  height: auto;
}

.flex.flex_between {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.flex.flex_around {
  justify-content: space-around;
  -webkit-justify-content: space-around;
}
.flex.ali_center {
  align-items: center;
  -webkit-align-items: center;
}
.flex.flex_center {
  justify-content: center;
  -webkit-justify-content: center;
}
.flex_col {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
}
.DatetimePicker {
  height: 6rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 1000;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
</style>
